/**
 * Created by fworld on 2019/7/24.
 */
import echarts from 'echarts'
import i18n from '@/i18n/i18n'

export default {
    grid: {
        left: '5%',
        right: '5%',
        top: '16%',
        bottom: '3%',
        containLabel: true
    },

    tooltip : {
        trigger: 'axis',
        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'cross'        // 默认为直线，可选为：'line' | 'shadow'
        },
    },

    xAxis: {
        name: '',
        nameTextStyle: {
            color: '#e1e1e1',
        },
        axisLabel: {
            color: '#e1e1e1',
            interval:0,
            rotate:40
        },
        axisLine: {
            show: false,
            lineStyle: {
                color: '#c9c9c9',
            }
        },
        splitLine: {
            show: false,
        },
        type: 'category',
        data: []
    },
    yAxis: {
        type: 'value',
        name: i18n.t('unit_cup'),
        axisLabel: {
            color: '#BAC3CE',
        },
        nameTextStyle: {
            color: '#e1e1e1',
            fontSize: 16,
            fontWeight: 600,
            padding: [0, 5, 0, 5]
        },
        axisLine: {
            lineStyle: {
                color: '#3c3c3c',
            }
        },
        axisTick: {
            show: false,
        },
        splitLine: {
            // show: false,
            lineStyle: {

                color: '#3c3c3c'
            }
        }
    },
    series: [{
        data: [],
        type: 'bar',
        barWidth : 15,
        // itemStyle: {
        //     normal: {
        //         color: '#0EBF9C'
        //     },
        //
        // },
        itemStyle: {
            normal: {
                color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                        {offset: 1, color: '#2378f7'},
                        {offset: 0.7, color: '#83bff6'},
                        {offset: 0.3, color: '#13b8b1'},
                        {offset: 0, color: '#0FB891'}
                    ]
                )
            },
            emphasis: {
                color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                        {offset: 0, color: '#2378f7'},
                        {offset: 0.7, color: '#83bff6'},
                        {offset: 1, color: '#0FB891'}
                    ]
                )
            }
        },
    }]
}
